import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { UiService } from '../ui/ui.service';
import { UserService } from '../user/user.service';

@Injectable()
export class HelperService {
  public hideStudentOfClasses = [];

  public capstoneBranches = [2];
  public currentBranchId = null;

  constructor(
    private router: Router,
    private user: UserService,
    private location: Location,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private ui: UiService
  ) {}

  static titleCase(value) {
    return value
      .split(/\s+/)
      .map(
        (str) =>
          (str && str[0] && String(str[0]).toUpperCase()) +
          (str && String(str).slice(1).toLowerCase())
      )
      .join(' ');
  }

  get baseRoute() {
    return '';
  }

  getDiplomaPaperText(number = 'singular', branchId = undefined) {
    branchId = branchId || this.user.userBranchId;
    if (!branchId) {
      return '';
    }
    const isCapstone = this.capstoneBranches.some(
      (branch) => branch == branchId
    );
    if (isCapstone) {
      return number === 'plural' ? 'Capstone Projects' : 'Capstone Project';
    }
    return number === 'plural' ? 'Diploma Papers' : 'Diploma Paper';
  }

  navigateBack() {
    this.location.back();
  }

  getSafeFileUrl(file) {
    return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
  }

  getDownloadablePath(file) {
    const filename = '/' + file.enc_name + '.' + file.extension;
    const filepath = file.tmp_path
      ? file.tmp_path + filename
      : file.path + filename;
    return environment.basePath + '/' + filepath;
  }

  fromRoman(str): number {
    if (!str) {
      return 0;
    }
    let result = 0;
    // the result is now a number, not a string
    const decimal = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
    const roman = [
      'M',
      'CM',
      'D',
      'CD',
      'C',
      'XC',
      'L',
      'XL',
      'X',
      'IX',
      'V',
      'IV',
      'I',
    ];
    decimal.forEach((value, i) => {
      while (str.indexOf(roman[i]) === 0) {
        //checking for the first characters in the string
        result += value;
        //adding the decimal value to our result counter
        str = str.replace(roman[i], '');
        //remove the matched Roman letter from the beginning
      }
    });
    return result;
  }

  validateDate(date) {
    return date
      ? date instanceof Date
        ? date
        : new Date(date.replace(/-/g, '/'))
      : null;
  }

  checkIfResponseNull(res) {
    return !res || (Array.isArray(res) && !res.length);
  }

  getProfileImageUrl(image) {
    return image
      ? environment.basePath + '/' + image
      : '../assets/img/icon-no-image.png';
  }

  handleError(err, type) {
    if (err) {
      if (Object.keys(err).length) {
        swal(this.toTitleCase(type), err[Object.keys(err)[0]], type);
      }
    }
    return true;
  }

  toTitleCase(str: string) {
    return str[0].toUpperCase() + str.slice(1);
  }

  downloadFile(file, callback) {
    console.log(file);
    const name = '/' + file.enc_name + '.' + file.extension;
    const pathToFile = file.tmp_path
      ? file.tmp_path + name
      : file.path
      ? file.path + name
      : file.enc_name;
    console.log(pathToFile);
    this.ui.loader.show();
    this.http
      .post('/download', { pathToFile }, { responseType: 'blob' })
      .subscribe(
        (res: any) => {
          this.ui.loader.hide();
          const downloadableName = file.title
            ? file.title + '.' + file.extension
            : file.name;
          FileSaver.saveAs(res, downloadableName);
        },
        (err) => {
          this.ui.loader.hide();
          console.log(err);
        }
      );
  }
}



// WEBPACK FOOTER //
// G:/UTL/Alumni/Alumni-ANG/src/app/services/helper/helper.service.ts